import { Component, Input } from '@angular/core';
import { Table } from 'primeng/table';
import { PaginationChange } from './pagination.component';

@Component({
  selector: 'ss-table-pagination',
  templateUrl: './table-pagination.component.html',
  standalone: false
})
export class TablePaginationComponent {
  @Input() table!: Table;
  @Input() label = 'resultados';

  get total(): number {
    return this.table.lazy ? this.table.totalRecords : (this.table.filteredValue || this.table.value || []).length;
  }

  get pageSize(): number { return this.table.rows || 15; }
  get page(): number { return Math.floor((this.table.first || 0) / this.pageSize) + 1; }
  get sizes(): number[] { return this.table.rowsPerPageOptions || [this.pageSize]; }

  change(change: PaginationChange): void {
    this.table.onPageChange({ first: (change.page - 1) * change.pageSize, rows: change.pageSize });
  }
}
